import axios from '../config/axiosConfig';

const API_URL = '/web-findings';

const webFindingService = {
  getAll: async (params = {}) => {
    const res = await axios.get(API_URL, { params });
    return res.data;
  },

  getById: async (id) => {
    const res = await axios.get(`${API_URL}/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await axios.post(API_URL, data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await axios.put(`${API_URL}/${id}`, data);
    return res.data;
  },

  updateStatus: async (id, status, notes) => {
    const res = await axios.put(`${API_URL}/${id}/status`, { status, notes });
    return res.data;
  },

  retest: async (id) => {
    const res = await axios.post(`${API_URL}/${id}/retest`);
    return res.data;
  },

  remove: async (id) => {
    const res = await axios.delete(`${API_URL}/${id}`);
    return res.data;
  },

  createActions: async (findingIds, operator, sourceIp) => {
    const res = await axios.post(`${API_URL}/create-actions`, { findingIds, operator, sourceIp });
    return res.data;
  },

  // Download the OpenJSON export for the reporting app.
  exportOpenJson: async (webTargetId, params = {}) => {
    const res = await axios.get(`${API_URL}/export/${webTargetId}`, { params, responseType: 'blob' });
    const cd = res.headers['content-disposition'] || '';
    const m = cd.match(/filename="?([^"]+)"?/);
    const filename = (m && m[1]) || 'findings-openjson.json';
    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/json' }));
    const a = document.createElement('a');
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click(); a.remove();
    window.URL.revokeObjectURL(url);
    return filename;
  }
};

export const severityConfig = {
  critical: { label: 'Critical', color: 'red', bg: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300' },
  high: { label: 'High', color: 'orange', bg: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300' },
  medium: { label: 'Medium', color: 'yellow', bg: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300' },
  low: { label: 'Low', color: 'blue', bg: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
  informational: { label: 'Info', color: 'gray', bg: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300' }
};

export const statusConfig = {
  new: { label: 'New', bg: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300' },
  open: { label: 'Open', bg: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
  confirmed: { label: 'Confirmed', bg: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300' },
  false_positive: { label: 'False Positive', bg: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300' },
  accepted_risk: { label: 'Accepted Risk', bg: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300' },
  remediated: { label: 'Remediated', bg: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300' }
};

export default webFindingService;
